// @ts-nocheck
import { useSelector } from 'react-redux';
import { get } from '@docavenue/core';
// eslint-disable-next-line import/prefer-default-export
export var useCurrentUser = function useCurrentUser() {
  return useSelector(function (state) {
    return get(state, 'authentication.item');
  });
};
//# sourceMappingURL=index.js.map